import { Component, OnDestroy, OnInit } from "@angular/core";

import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { sleep } from "../../../_helpers/sleep";
import { ParentEventFromSearch } from "../../events-screen/event-page-models/parent-event-from-search";
import { SpecificEventTypeOptions } from "../../events-screen/parent-events-page/parent-event-type-options/parent-event-type-options";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import {
  FamilyMemberWithSiblingsModel,
  FamilyModel,
} from "../brother-attribution-models/family-model";
import { BrotherAttributionPageMainModalContainerComponent } from "../brother-attribution-page-main-modal-container/brother-attribution-page-main-modal-container.component";
import { BrotherAttributionModalType } from "../brother-attribution-models/brother-attribution-modal-type";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { ToastsManager } from "ng2-toastr";
import { PopoverService } from "../../../_services/popover.service";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { BrotherAttributionService } from "../../../_services/brother-attribution.service";

@Component({
  selector: "brothers-attribution-page",
  templateUrl: "./brothers-attribution-page.component.html",
  styleUrls: [
    "../../events-screen/parent-events-page/parent-events-page.component.scss",
    "./brothers-attribution-page.component.scss",
  ],
  //event-page-search.component
})
export class BrothersAttributionPage implements OnInit, OnDestroy {
  public translations$: Observable<ITranslations>;

  public isMock: boolean = false;

  public readonly $siblingRequests: BehaviorSubject<FamilyModel[]> =
    new BehaviorSubject<FamilyModel[]>(null);

  public readonly $openDeleteModal: BehaviorSubject<
    ParentEventFromSearch | false
  > = new BehaviorSubject<ParentEventFromSearch | false>(false);
  public scrollCallback: ($event: any) => void;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private translationService: TranslationService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private toaster: ToastsManager,
    private popoverService: PopoverService,
    private brotherAttributionService: BrotherAttributionService,
    private sessionManagerService: SessionManagerService
  ) {
    this.isMock = !window.location.href.includes("admin");
    this.translations$ = this.translationService.translations;
    this.subscribeToSiblingAttributionRequests();

    this.scrollCallback = this.scrollCallbackHandler.bind(this);
  }

  public get isDevelopmentMode() {
    return this.sessionManagerService.isDevModeActive();
  }
  public toastMessage(message: string) {
    const options = {
      positionClass: "toast-top-center",
      maxShown: 2,
      newestOnTop: true,
      animate: true,
      toastLife: 10,
      enableHTML: true,
      dismiss: true,
      messageClass: "toast-message",
      titleClass: "toast-title",
      showCloseButton: true,
    };
    this.popoverService.popMessage(message);
  }
  public ngOnInit(): void {
    if (!this.isMock) {
      return;
    }
  }

  public ngOnDestroy(): void {}

  public async rowEventHandler($event: GeneralRowEvent<FamilyModel>) {
    if (!$event.eventObject || !$event.eventObject.requestId) {
      return;
    }

    let foundEvent: FamilyModel | null = $event.eventObject;
    const saveResult =
      await this.brotherAttributionService.handleSiblingRequest(
        +$event.eventObject.requestId,
        $event.action === "approve" ? "approve" : "disapprove"
      );
    if (saveResult.success === false) {
      this.modalNotification(
        this.translationService.currentTranslations.general_error +
          " " +
          saveResult.error.toString()
      );
      return;
    }

    const lastName = foundEvent.members[0].lastName;

    if ($event.action === "approve") {
      this.toastMessage("הבקשה אושרה בהצלחה" + ` (${lastName})`);
    } else if ($event.action === "delete") {
      this.toastMessage("בקשת השיוך נדחתה" + ` (${lastName})`);
    }
    // updating
    this.brotherAttributionService.getAllSiblingRequests();
  }
  public editChild(child: FamilyMemberWithSiblingsModel) {
    const family: FamilyModel =
      BrotherAttributionService.serializeFamilyMemberWithSiblingsToFamilyModel(
        child
      );
    const modalRefEdit: NgbModalRef = this.modalService.open(
      BrotherAttributionPageMainModalContainerComponent,
      BrotherAttributionPageMainModalContainerComponent.modalOptions
    );
    (
      modalRefEdit.componentInstance as BrotherAttributionPageMainModalContainerComponent
    ).familyToEdit = family;
    (
      modalRefEdit.componentInstance as BrotherAttributionPageMainModalContainerComponent
    ).brotherAttributionModalType =
      BrotherAttributionModalType.editFamilyConnection;
  }
  public editFamilyFromSearchResults(
    familyEvent: GeneralRowEvent<FamilyModel>
  ) {
    const modalRefEdit: NgbModalRef = this.modalService.open(
      BrotherAttributionPageMainModalContainerComponent,
      BrotherAttributionPageMainModalContainerComponent.modalOptions
    );
    (
      modalRefEdit.componentInstance as BrotherAttributionPageMainModalContainerComponent
    ).familyToEdit = familyEvent.eventObject;
    (
      modalRefEdit.componentInstance as BrotherAttributionPageMainModalContainerComponent
    ).brotherAttributionModalType =
      BrotherAttributionModalType.editFamilyConnection;
  }

  public modalResultHandler($event: any) {}

  public scrollCallbackHandler($event: any) {}
  public createNewFamily() {
    const modalRef: NgbModalRef = this.modalService.open(
      BrotherAttributionPageMainModalContainerComponent,
      BrotherAttributionPageMainModalContainerComponent.modalOptions
    );

    (
      modalRef.componentInstance as BrotherAttributionPageMainModalContainerComponent
    ).brotherAttributionModalType =
      BrotherAttributionModalType.createNewFamilyConnection;
  }

  protected modalNotification(message: string) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שיוך אחים ואחיות",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }
  private subscribeToSiblingAttributionRequests(): void {
    this.brotherAttributionService
      .getAllSiblingRequests()
      .subscribe((childrenFamilies: FamilyModel[]) => {
        this.$siblingRequests.next(childrenFamilies);
      });
    this.brotherAttributionService.getSiblingRequests().then();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brothers-attribution-page/brothers-attribution-page.component.ts